import { BenefitRequest, FetchPlanResponse, GetBenefitsResponse, SetBenefitRequest } from "Application/models";
import { APICallInstance } from "./APICallInstance";
import { AxiosResponse } from "axios";


export const fetchBenefits = async () => {
    const url = 'api/v1/benefit';

    try {
        const response: AxiosResponse<GetBenefitsResponse> = await APICallInstance.get(url);
        console.log(response)
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const addBenefit = async (createBenefitsData: BenefitRequest) => {
    const url = 'api/v1/benefit';

    try {
        const response: AxiosResponse<GetBenefitsResponse > = await APICallInstance.post(url, createBenefitsData);
        console.log(response)
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const setBenefitOnPlan = async (setBenefitsData: SetBenefitRequest, planId:any) => {
    const url = `api/v1/plan/${planId}/add/benefit`;

    try {
        const response: AxiosResponse<FetchPlanResponse > = await APICallInstance.put(url, setBenefitsData);
        console.log(response)
        return response.data;
    } catch (error) {
        throw error;
    }
}
